function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import { AppContext } from 'context';
import OptionBox from 'components/Form/OptionBox';
import intlShape from 'shapes/intlShape';
import App from 'modules/App';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import messages from '../../messages';
var _React_PureComponent;
class ProfileOptionBox extends (_React_PureComponent = React.PureComponent) {
    get countryName() {
        const { countryCode: alpha2Code } = this.props.identity;
        const country = find(this.props.countries, {
            alpha2Code
        });
        return get(this.props.localizationResources, [
            country.nameKey,
            'value'
        ], country.englishName);
    }
    get imageFile() {
        const { countryCode } = this.props.identity;
        return `${countryCode}.svg`;
    }
    get profileName() {
        const { scope } = this.props.identity;
        return this.props.intl.formatMessage(messages.scopes[scope]);
    }
    renderLabel() {
        const { countryName, profileName } = this;
        return /*#__PURE__*/ _jsxs("div", {
            className: "row align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx("figure", {
                        className: "linkTile__image linkTile__image--border",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: `/aid/assets/svg/flags/${this.imageFile}`,
                            alt: countryName
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        countryName,
                        /*#__PURE__*/ _jsx("span", {
                            className: "text--secondary text--normal mx-3",
                            children: "|"
                        }),
                        profileName
                    ]
                })
            ]
        });
    }
    render() {
        const { identityUID, countryCode, scope } = this.props.identity;
        const formValue = get(this.props.formValues, 'values.identityUID');
        return /*#__PURE__*/ _jsx(OptionBox, {
            id: "identityUID",
            value: formValue,
            inputValue: identityUID,
            labelMessage: this.renderLabel(),
            isReverted: true,
            onChange: this.props.onSetFormValue
        }, `${countryCode}-${scope}`);
    }
}
_define_property(ProfileOptionBox, "contextType", AppContext);
_define_property(ProfileOptionBox, "propTypes", {
    // Explicit props
    identity: shapes.identity,
    // Implicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    formValues: PropTypes.object,
    intl: intlShape.isRequired,
    // Implicit actions
    onSetFormValue: PropTypes.func
});
const mapStateToProps = (state)=>({
        countries: App.selectors.countries(state),
        localizationResources: App.selectors.localizationResources(state),
        formValues: App.selectors.formSelector(constants.ACCEPT_INVITATION_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.ACCEPT_INVITATION_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input))
    };
};
const ConnectedProfileOptionBox = connect(mapStateToProps, mapDispatchToProps)(ProfileOptionBox);
export default injectIntl(ConnectedProfileOptionBox);
